import $ from 'jquery';

$.fn.currency = function(options) {

	const settings = $.extend({
	 	serviceUrl : "/currency.php"
	}, options );

	const request = $.ajax({
		url:settings.serviceUrl,
		dataType:"json"
	})

    return this.each(function() {
		const parent = $(this);


		request.done((response) => {

			const rows = Object.keys(response).map((rowIndex) => {
				let row = response[rowIndex];
				return (
					'<div class="currency--row">' +
						`<div class="currency--cell">${row[0]}</div>` +
						`<div class="currency--cell">${row[1]}</div>` +
						`<div class="currency--cell"><i class="currency--status--${row[3]}"></i></div>` +
						`<div class="currency--cell">${row[2]}</div>` +
					'</div>'
				)
			});
			parent.html(rows);
		})

    });

};


export default class Currency {
	constructor(selector,options = {}){
		$(selector).currency(options)
	}
}



// WEBPACK FOOTER //
// ./src/scripts/currency.js